export const cleanDrops = (max, key, newVal) => {
   const newStatus = new Array(max).fill(0);
   newStatus[key] = newVal;
   return newStatus;
};

export const flexCreator = (justify, align, direction) => {
   // flex-start";

   function dictionary(val) {
      switch (val) {
         case "end":
            return "flex-end";
         case "start":
            return "flex-start";
         case "between":
            return "space-between";
         case "around":
            return "space-around";
         case "center":
            return "center";
         default:
            return "flex-start";
      }
   }

   justify = dictionary(justify);
   align = dictionary(justify);
   direction = direction || "row";

   return `
      display: flex;
      justify-content: ${justify};
      align-items: ${align};
      flex-direction: ${direction}
   `;
};

export const orderDataByIndex = data => {
   function compare(a, b) {
      let itemA = a.id;
      let itemB = b.id;
      let comparison = 0;
      if (itemA > itemB) {
         comparison = 1;
      } else if (itemA < itemB) {
         comparison = -1;
      }
      return comparison;
   }

   const toReturn = data.sort(compare);
   return toReturn.reverse();
};

export const simpleDate = date => {
   const current = new Date(date);
   let dateF = `${current.getDate()}/${Meses[current.getMonth()]}/${current.getFullYear()}`;
   return dateF;
};

export const Meses = [
   "Enero",
   "Febrero",
   "Marzo",
   "Abril",
   "Mayo",
   "Junio",
   "Julio",
   "Agosto",
   "Septiembre",
   "Octubre",
   "Noviembre",
   "Diciembre",
];

export const filterSearch = (val, item) => {
   // const objeto = [...AdminsData];
   // recorrero obbjeto y cada elemento pasarlo a una cadena en minuscla
   // buscar que tenga el valor en cualquier lugar
   /* let filtered = objeto.filter(item =>
      JSON.stringify(item)
         .toLocaleLowerCase()
         .indexOf(val.toLocaleLowerCase()),
   ); */

   let valid =
      JSON.stringify(item)
         .toLocaleLowerCase()
         .indexOf(val.toLocaleLowerCase()) > -1;
   return valid;
};
